/* eslint-disable @typescript-eslint/no-unused-vars */
import db from "../util/database";
import Tables from "../util/tables";
import questions from '../data/questions.json';
import unites from '../data/unites.json';

function insertClients() {
  db().collection(Tables.CLIENTS).add({
    idclient: '1',
    dossier: 'handicall',
    nom: 'Olivier',
    prenom: 'Foult',
    telf: '',
    telm: '',
    email: 'olivier.foult@test.com',
    adresse1: '',
    adresse2: '',
    codepostal: '',
    ville: '',
    emailagent: 'agent@handicall.com',
    telagent: '',
    partenaire: '',
    campagne: '',
    dlu: '',
    created_at: '',
    updated_at: '',
  });
}

export async function insertQuestionnaires() {
  const questionnaires = await db().collection(Tables.QUESTIONS).get();
  if (questionnaires.length === 0) {
    console.log('[insertQuestionnaires] inserting questions');
    await db().collection(Tables.QUESTIONS).set([]);
    await db().collection(Tables.QUESTIONS).set(questions.questions);
  }
}

export async function insertUnites() {
  const currentUnites = await db().collection(Tables.UNITES).get();
  if (true) { // currentUnites.length === 0) {
    console.log('[insertQuestionnaires] inserting unites');
    await db().collection(Tables.UNITES).set([]);
    await db().collection(Tables.UNITES).set(unites);

  }
}